import { API_PUBLIC_HOST } from "@/_constant";
import api from "./request";

export const fetchFilteredCategories = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await api.post(
        `${API_PUBLIC_HOST}/category/filterCategories`,
        payload
      );
      resolve(response);
    } catch (err) {
      reject(err);
    }
  })
};

export const listOfferZoneCategories = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await api.post(
        `${API_PUBLIC_HOST}/category/listOfferZoneCategories`,
        payload
      );
      resolve(response);
    } catch (err) {
      reject(err);
    }
  })
};

export const fetchCategoryBySlug = (slug) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url = `${API_PUBLIC_HOST}/lookup/findCategoryByKey?key=${slug}`;
      const res = await api.get(url);
      resolve(res);
    } catch (err) {
      reject(err);
    }
  });
}

export const fetchCategoryHierarchyByKey = (
  key,
  {
    sendChildren = false,
    sendAncestors = true,
    sendDescendants = false,
  } = {}
) => {
  const url = `${API_PUBLIC_HOST}/lookup/getCategoryHierarchyByKey`;
  return api.get(url, {
    params: {
      key,
      sendChildren,
      sendAncestors,
      sendDescendants,
    },
  });
}

export const fetchCategoryTree = (slug) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url = `${API_PUBLIC_HOST}/lookup/getCategoryTree?categoryKey=${slug}&maxLevel=1`;
      const res = await api.get(url);
      resolve(res);
    } catch (err) {
      reject(err);
    }
  });
}

export const fetchCategoryDetails = (categoryId) => {
  const url = `${API_PUBLIC_HOST}/category/viewCategory?categoryId=${categoryId}`;
  return api.get(url);
}

export const fetchDealerCategories = () => {
  const url = `${API_PUBLIC_HOST}/category/listDealerCategories`;
  return api.get(url);
};

export const fetchServiceProviderCategories = () => {
  const url = `${API_PUBLIC_HOST}/category/listServiceProviderCategories`;
  return api.get(url);
};
